import axios from 'axios'
import { api_lp, api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'
import router from '../../router'
import moment from 'moment'

const monitoringStore = {
  namespaced: true,
  state: () => ({
    total_vendor: 0,
    vendor_complete: 0,
    vendor_not_complete: 0,
    vendor_expired: 0,
    vendor_expire_soon: 0,

    detail_sio_by_vendor: [],
    sio_expire_soon: [],
    expire_soon_k3l_kplh: [],
    k3l_status: {},
    kplh_status: {},
    sio_by_vendor: {},
    sio_by_activity: {},
    vendor_legal_doc: [],

    date_range: 0,
    start: '',
    end: '',
    bisnis_unit: '',
    badan_usaha: '',
    company_code: '',
    region: '',
    kbli: '',
    afiliasi: '',
    sio: '',

    header_loading: false,
    detail_sio_by_vendor_loading: false,
    sio_expire_soon_loading: false,
    expire_soon_k3l_kplh_loading: false,
    k3l_status_loading: false,
    kplh_status_loading: false,
    sio_by_vendor_loading: false,
    sio_by_activity_loading: false,
    vendor_legal_doc_loading: false,
  }),
  mutations: {
    UPDATE_DATA(state, payload) {
      state[payload.name] = payload.value
    },
    DEFAULT_HEADER(state, payload) {
      state.total_vendor = 0
      state.vendor_complete = 0
      state.vendor_not_complete = 0
      state.vendor_expired = 0
      state.vendor_expire_soon = 0
    },
    UPDATE_HEADER(state, payload) {
      state.total_vendor = payload.total_vendor
      state.vendor_complete = payload.vendor_complete
      state.vendor_not_complete = payload.vendor_not_complete
      state.vendor_expired = payload.vendor_expired
      state.vendor_expire_soon = payload.vendor_expire_soon
    },
  },
  actions: {
    getHeader: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, badan_usaha } = state
      await commit('UPDATE_DATA', { name: 'header_loading', value: true })
      await commit('DEFAULT_HEADER')

      let url = `${api}/api/v1/dashboard-monitoring/header?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (bisnis_unit == 'BCE' && company_code) url += `&kode=${company_code}`
      if (badan_usaha) url += `&badan_usaha=${badan_usaha}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_HEADER', data.data)
          await commit('UPDATE_DATA', { name: 'header_loading', value: false })
        }
      } catch (error) {
        await commit('DEFAULT_HEADER')
        await commit('UPDATE_DATA', { name: 'header_loading', value: false })
      }
    },

    getDetailSioByVendor: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, badan_usaha } = state
      await commit('UPDATE_DATA', {
        name: 'detail_sio_by_vendor_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'detail_sio_by_vendor',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-monitoring/detail-sio-by-vendor?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (badan_usaha) url += `&badan_usaha=${badan_usaha}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'detail_sio_by_vendor',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'detail_sio_by_vendor_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'vendor_per_region',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'vendor_per_region_loading',
          value: false,
        })
      }
    },
    getSioExpireSoon: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, badan_usaha } = state
      await commit('UPDATE_DATA', {
        name: 'sio_expire_soon_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'sio_expire_soon',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-monitoring/sio-expire-soon?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (badan_usaha) url += `&badan_usaha=${badan_usaha}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'sio_expire_soon',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'sio_expire_soon_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'sio_expire_soon',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'sio_expire_soon_loading',
          value: false,
        })
      }
    },
    getExpireSoonK3lKplh: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, badan_usaha } = state
      await commit('UPDATE_DATA', {
        name: 'expire_soon_k3l_kplh_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'expire_soon_k3l_kplh',
        value: [],
      })

      let url = `${api}/api/v1/dashboard-monitoring/expire-soon-k3l-kplh?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (badan_usaha) url += `&badan_usaha=${badan_usaha}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'expire_soon_k3l_kplh',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'expire_soon_k3l_kplh_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'expire_soon_k3l_kplh',
          value: [],
        })
        await commit('UPDATE_DATA', {
          name: 'expire_soon_k3l_kplh_loading',
          value: false,
        })
      }
    },
    getKplhStatus: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, badan_usaha } = state
      await commit('UPDATE_DATA', {
        name: 'kplh_status_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'kplh_status',
        value: {},
      })

      let url = `${api}/api/v1/dashboard-monitoring/kplh-status?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (badan_usaha) url += `&badan_usaha=${badan_usaha}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'kplh_status',
            value: data.data[0],
          })
          await commit('UPDATE_DATA', {
            name: 'kplh_status_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'kplh_status',
          value: {},
        })
        await commit('UPDATE_DATA', {
          name: 'kplh_status_loading',
          value: false,
        })
      }
    },
    getK3lStatus: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, badan_usaha } = state
      await commit('UPDATE_DATA', {
        name: 'k3l_status_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'k3l_status',
        value: {},
      })

      let url = `${api}/api/v1/dashboard-monitoring/k3l-status?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (badan_usaha) url += `&badan_usaha=${badan_usaha}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'k3l_status',
            value: data.data[0],
          })
          await commit('UPDATE_DATA', {
            name: 'k3l_status_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'k3l_status',
          value: {},
        })
        await commit('UPDATE_DATA', {
          name: 'k3l_status_loading',
          value: false,
        })
      }
    },

    getSioByVendor: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, badan_usaha } = state
      await commit('UPDATE_DATA', {
        name: 'sio_by_vendor_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'sio_by_vendor',
        value: {},
      })

      let url = `${api}/api/v1/dashboard-monitoring/sio-by-vendor?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (badan_usaha) url += `&badan_usaha=${badan_usaha}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'sio_by_vendor',
            value: data.data[0],
          })
          await commit('UPDATE_DATA', {
            name: 'sio_by_vendor_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'sio_by_vendor',
          value: {},
        })
        await commit('UPDATE_DATA', {
          name: 'sio_by_vendor_loading',
          value: false,
        })
      }
    },
    getSioByActivity: async ({ commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, badan_usaha } = state
      await commit('UPDATE_DATA', {
        name: 'sio_by_activity_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'sio_by_activity',
        value: {},
      })

      let url = `${api}/api/v1/dashboard-monitoring/sio-by-activity?`
      if (bisnis_unit) url += `&bisnis_unit=${bisnis_unit}`
      if (company_code) url += `&kode=${company_code}`
      if (badan_usaha) url += `&badan_usaha=${badan_usaha}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'sio_by_activity',
            value: data.data[0],
          })
          await commit('UPDATE_DATA', {
            name: 'sio_by_activity_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'sio_by_activity',
          value: {},
        })
        await commit('UPDATE_DATA', {
          name: 'sio_by_activity_loading',
          value: false,
        })
      }
    },

    getVendorLegalDoc: async ({ commit, state, rootState }, payload) => {
      const { start, end } = state
      await commit('UPDATE_DATA', {
        name: 'vendor_legal_doc_loading',
        value: true,
      })
      await commit('UPDATE_DATA', {
        name: 'vendor_legal_doc',
        value: {},
      })

      let url = `${api}/api/v1/dashboard-monitoring/vendor-legal-doc?`
      if (start && end) url += `&start=${start}&end=${end}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          await commit('UPDATE_DATA', {
            name: 'vendor_legal_doc',
            value: data.data,
          })
          await commit('UPDATE_DATA', {
            name: 'vendor_legal_doc_loading',
            value: false,
          })
        }
      } catch (error) {
        await commit('UPDATE_DATA', {
          name: 'vendor_legal_doc',
          value: {},
        })
        await commit('UPDATE_DATA', {
          name: 'vendor_legal_doc_loading',
          value: false,
        })
      }
    },

    filterDate: async ({ dispatch, commit, state, rootState }, payload) => {
      await dispatch('getDetailSioByVendor')
      await dispatch('getSioExpireSoon')
      await dispatch('getExpireSoonK3lKplh')
      await dispatch('getK3lStatus')
      await dispatch('getKplhStatus')
      await dispatch('getSioByVendor')
      await dispatch('getSioByActivity')
      await dispatch('getVendorLegalDoc')
    },
    allFilter: async ({ dispatch, commit, state, rootState }, payload) => {
      const { bisnis_unit, company_code, badan_usaha, start, end } = state
      await dispatch('getHeader')

      if (bisnis_unit || company_code || badan_usaha || (start && end)) {
        await dispatch('getDetailSioByVendor')
        await dispatch('getSioExpireSoon')
        await dispatch('getExpireSoonK3lKplh')
        await dispatch('getK3lStatus')
        await dispatch('getKplhStatus')
        await dispatch('getSioByVendor')
        await dispatch('getVendorLegalDoc')
      }
    },
  },
}

export default monitoringStore
